import { StorageAllocation, StorageAllocationProps } from './storage_allocation.component';


export interface StorageAllocationItem extends Omit<StorageAllocationProps, 'onQuotaChange' | 'onAlertEnabledChange' | 'onAlertThresholdChange'> {
  id: string;
}

interface StorageAllocationListProps {
  title: string;
  items: StorageAllocationItem[];
  onItemChange?: ( updatedItem: StorageAllocationItem ) => void;
}

export function StorageAllocationList( { title, items, onItemChange }: StorageAllocationListProps ) {
  const handleChange = (
    item: StorageAllocationItem,
    patch: Partial<Pick<StorageAllocationItem, 'quota' | 'alertEnabled' | 'alertThreshold'>>
  ) => {
    if ( onItemChange ) {
      onItemChange( { ...item, ...patch } );
    }
  };

  return (
    <div className='flex flex-col gap-4 w-full'>
      <h2 className='text-base font-semibold text-gray-800'>{ title }</h2>
      <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 items-start'>
        { items.map( item => {return (
          <StorageAllocation
            key={ item.id }
            icon={ item.icon }
            title={ item.title }
            maxQuota={ item.maxQuota }
            used={ item.used }
            quota={ item.quota }
            alertEnabled={ item.alertEnabled }
            alertThreshold={ item.alertThreshold }
            unit={ item.unit }
            disabled={ item.disabled }
            onQuotaChange={ value => { handleChange( item, { quota: value } ); } }
            onAlertEnabledChange={ value => { handleChange( item, { alertEnabled: value } ); } }
            onAlertThresholdChange={ value => { handleChange( item, { alertThreshold: value } ); } }
          />
        );} ) }
      </div>
    </div>
  );
}
